// @flow

export const transformBar = (num: number): Object => {
  if (typeof num !== 'number' || !Number(num)) num = 0.5
  if (num <= 0.5 || !num) num = 0.5
  if (num >= 100) num = 100
  const scaleString = `scale(${num / 100}, 1)`
  return {
    WebkitTransformOrigin: 'left',
    transformOrigin: 'left',
    msTransform: scaleString,
    WebkitTransform: scaleString,
    transform: scaleString
  }
}

export const transformText = (num: number, textLength: number): Object => {
  const offset = 31 + textLength * 9
  let translateString = `translateX(calc(${-100 + num}% + ${offset}px))`

  if (num === 100) {
    translateString = 'none'
  } else if (num >= 80) {
    translateString = `translateX(calc(-${100 - num}%))`
  }
  return {
    msTransform: translateString,
    WebkitTransform: translateString,
    transform: translateString
  }
}

export const calculateTextOffset = (textOffset: number): Object => {
  const textOffsetInPx = `${textOffset * 7 + 10}px`

  return {
    width: `calc(100% - ${textOffsetInPx})`
  }
}

export const calculateTextWidth = (textOffset: number): string => {
  return `${textOffset * 7 + 10}px`
}



// WEBPACK FOOTER //
// ./src/shared/utils/barUtils/barUtils.js